module.exports = __webpack_public_path__ + "img/cheerReg.06747180.png";